import { ELSIcon } from 'components/common/els';

const RoundCloseIcon = (props: {msg: string}) => (
    <span 
    tabIndex={0}
    role="img"
    className="round-close-icon-wrapper"
    aria-label={props.msg}
    style={{ display: 'inline-block' }}
  >
    <ELSIcon name="close" size="1x" align="sub" color="white" customClass="round-icon round-icon--fail" />
  </span>
);

RoundCloseIcon.displayName = 'RoundCloseIcon';
export default RoundCloseIcon;
